<template>
	<SelectInline
		v-model="publicTransport"
		:characteristic-items="meta.publicTransport"
		:characteristic-type="meta.publicTransportType"
		:nothing-allowed="{
			text: 'Egal'
		}"
		initial-show-all
		label-type="application"
		show-multiple-hint
		@input="emitChangeEvent"
	/>
</template>
<script>
import {isDefined} from "@/helper/Value";
import SelectInline from "@/vue/characteristic/SelectInline";
import {mapState} from "vuex";

export default {

	components: {
		SelectInline,
	},

	props: {
		value: {
			type: Object,
			required: false,
		},
	},

	data ()
	{
		return {
			publicTransport: this.value?.publicTransport,
		};
	},

	computed: {
		...mapState('meta', ['meta']),
		dataValid ()
		{
			return isDefined(this.publicTransport);
		},
	},

	methods: {
		emitChangeEvent ()
		{
			if (!this.dataValid)
			{
				this.$emit('input', undefined);
				return;
			}

			this.$emit('input', {
				publicTransport: this.publicTransport
			});
		},
	}
}
</script>
